var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLink = function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22351_49570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5 11.25C10.5 9.59325 11.8433 8.25 13.5 8.25H15.375C17.2388 8.25 18.75 9.76125 18.75 11.625C18.75 13.4887 17.2388 15 15.375 15H15",
    stroke: "#D1D1D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12C13.5 13.6568 12.1568 15 10.5 15H8.625C6.76125 15 5.25 13.4887 5.25 11.625C5.25 9.76125 6.76125 8.25 8.625 8.25H9",
    stroke: "#D1D1D6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22351_49570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(3 3)"
  })))));
};
export { SvgLink as ReactComponent };
export default __webpack_public_path__ + "link.svg";